import { Order } from '@spa/store/modules/orderHistory/types'
import { EngineStatus, EngineStatusFactory, StoreEngineStatusFactory } from './engine-status'
import { HistoryError, HistoryErrorList, HistoryErrorListFactory, StoreHistoryErrorListFactory } from './history-error'
import { PaymentType, PaymentTypeFactory, StorePaymentTypeFactory } from './payment-type'

/**
 * 注文の状態を表現するうえで頻繁に利用される情報をひとまとめにしたもの
 *
 * 常にこれらの情報がセットで利用されるとは限らず、また、これらの情報で常に十分であるわけでもない
 * したがってContextは分解されるべきかもしれないが、これまで「注文の状態」を表すためのひとかたまりの情報としてある程度安定していたので利用を継続する
 */
export interface Context {
  engineStatus: EngineStatus
  historyErrorList: HistoryErrorList<HistoryError>,
  paymentType: PaymentType,
}

export class ContextFactory {
  static fromStore(order: Order): ContextFactory {
    return new ContextFactory(
      new StoreEngineStatusFactory(order),
      new StoreHistoryErrorListFactory(order),
      new StorePaymentTypeFactory(order)
    )
  }

  private constructor(
    private readonly engineStatusFactory: EngineStatusFactory,
    private readonly historyErrorListFactory: HistoryErrorListFactory,
    private readonly paymentTypeFactory: PaymentTypeFactory
  ) {}

  create(): Context {
    return {
      engineStatus: this.engineStatusFactory.create(),
      historyErrorList: this.historyErrorListFactory.create(),
      paymentType: this.paymentTypeFactory.create(),
    }
  }
}
